import moment, { Moment } from 'moment';

type SchedulerTimeInput = Date | string | Moment;

/**
 * Compact scheduler time label: 1AM, 2AM, 12PM, or 3:45AM when minutes are non-zero.
 * No leading zero on hour, no space before AM/PM.
 */
export function formatSchedulerTime(input: SchedulerTimeInput): string {
	const m = moment(input);
	const hour24 = m.hour();
	const minutes = m.minute();
	const period = hour24 >= 12 ? 'PM' : 'AM';
	const hour12 = hour24 % 12 || 12;
	const timePart =
		minutes === 0 ? `${hour12}` : `${hour12}:${String(minutes).padStart(2, '0')}`;
	return `${timePart}${period}`;
}

/**
 * Compact scheduler time range: 6AM - 10AM, 3:45AM - 8:30PM
 */
export function formatSchedulerTimeRange(
	start: SchedulerTimeInput,
	end: SchedulerTimeInput
): string {
	return `${formatSchedulerTime(start)} - ${formatSchedulerTime(end)}`;
}

/**
 * Compact hours worked label: 5H or 8.5H
 */
export function formatSchedulerHours(hours: number): string {
	const rounded = Math.round(hours * 10) / 10;
	const formatted = Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
	return `${formatted}H`;
}

export default formatSchedulerTime;
